import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeScript, SafeResourceUrl } from '@angular/platform-browser'

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer:DomSanitizer) {}

  transform(v: string): SafeHtml {

    var r = this._sanitizer.bypassSecurityTrustHtml(v)
    return r

  }

}
